import DataTable from 'react-data-table-component'
import { columns } from './table'
import { ChevronDown } from 'react-feather'
import ReactPaginate from 'react-paginate'
import { Fragment } from 'react'
import { Card } from 'reactstrap'
import { ReceptionDocumentsFilters } from './components/filters'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentPage } from './store'

function ReceptionDocuments() {
  const dispatch = useDispatch()
  const { currentPage, data, isPending, totalPages } = useSelector(
    (state) => state.receptionDocuments
  )

  const handlePagination = (page) => {
    if (isPending) {
      return
    }

    dispatch(setCurrentPage(page.selected + 1))
  }

  const CustomPagination = () => {
    return (
      <ReactPaginate
        onClick={(event) => {
          if (isPending) {
            return false
          }

          return event.nextSelectedPage
        }}
        previousLabel={
          <Fragment>
            <span className="align-middle d-none d-md-inline-block">
              Anterior
            </span>
          </Fragment>
        }
        nextLabel={
          <Fragment>
            <span className="align-middle d-none d-md-inline-block">
              Siguiente
            </span>
          </Fragment>
        }
        forcePage={currentPage}
        onPageChange={(page) => handlePagination(page)}
        pageCount={totalPages}
        breakLabel={'...'}
        pageRangeDisplayed={5}
        marginPagesDisplayed={5}
        activeClassName={'active'}
        pageClassName={'page-item'}
        nextLinkClassName={'page-link'}
        nextClassName={'page-item next'}
        previousClassName={'page-item prev'}
        previousLinkClassName={'page-link'}
        pageLinkClassName={'page-link'}
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName={
          'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'
        }
      />
    )
  }

  return (
    <Fragment>
      <ReceptionDocumentsFilters />

      {data.length > 0 && (
        <Card>
          <div className={`react-dataTable master-view-batch-table shrink-table`}>
            <DataTable
              noHeader
              pagination
              columns={columns()}
              paginationPerPage={20}
              className="react-dataTable"
              responsive={true}
              sortIcon={<ChevronDown size={10} />}
              paginationComponent={CustomPagination}
              // paginationDefaultPage={currentPage}
              data={data}
            />
          </div>
        </Card>
      )}
    </Fragment>
  )
}

export default ReceptionDocuments
